module.exports = __webpack_public_path__ + "static/media/74.4737286c.webp";